export default "__VITE_ASSET__PP_RXGfJ__"